import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {STPMain} from "../../models/stp_main.model";
import {StpTrainer} from "../../models/stp-trainer.model";
import {StpOccupationTool} from "../../models/stp-occupation-tool.model";
import {Furniture} from "../../models/furniture.model";
import {StpManagement} from "../../models/stp-management.model";
import {District, Division, Upazila} from "../../../../shared/models/common.model";
import {Subscription} from "rxjs";
import {DatePipe} from "@angular/common";
import {CommonStorageService} from "../../../../shared/services/common-storage.service";
import {StpRegistrationStorageService} from "../../services/stp-registration-storage.service";
import {StpRegistrationService} from "../../services/stp-registration.service";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {UserStorageService} from "../../../user/services/user-storage.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FinancialStorageService} from "../../../financial-application/services/financial-storage.service";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {saveAs} from "file-saver";
import {applicationPermissions} from 'src/app/shared/application-constants/application-permissions';

@Component({
  selector: 'app-previous-stp-application-view',
  templateUrl: './previous-stp-application-view.component.html',
  styleUrls: ['./previous-stp-application-view.component.scss']
})
export class PreviousStpApplicationViewComponent implements OnInit {

  @Input() stpMainId: string | null;
  @Input() applicationId: string | null = null;
  fullStpApplicationDetails: any;

  editable: boolean = true;
  basicProfileForm!: FormGroup;
  approveRejectForm!: FormGroup;
  physicalInfraForm!: FormGroup;
  paymentForm!: FormGroup;

  stpPrvAppId: string;

  pdfBlob: File;

  financialDetailForm!: FormGroup;
  isEditMode!: boolean;
  stpMain!: STPMain;

  stpTrainers: StpTrainer[] = [];
  stpOccupationTools: StpOccupationTool[] = [];
  furnitures: Furniture[] = [];
  stpManagements: StpManagement[] = [];

  isCommitte: boolean;

  isApplicationSubmitted: boolean = false;

  divisions: Division[] = [];
  districts: District[] = [];
  upazilas: Upazila[] = [];


  stpName = '';
  stpApplicationId: number;
  totalIncomes: number;
  totalExpenses: number;
  currentUserInfo: any;
  userInfo: any;
  userId: any;
  userInfoId: any
  userEmail: any;
  isUser: boolean = false;
  isAdmin: boolean = false;
  isManualPayment = false;
  isOnlinePayment = false;
  paySlip: String;
  isComplete$: Subscription;
  transactionNumber: any;

  applicationPermissions = applicationPermissions;
  isTempRejected: any;
  approvalStatus: any;

  tempRejectReason: string;
  isShown: boolean = false;

  stpEmail: string;
  stpContactEmail: string;
  stpExpireDate: Date;
  isStpExpired: boolean = false;

  paymentIssueForm: FormGroup;
  isVisible = false;

  financingApplicationList: any;

  constructor(
    // private tab: StpTabComponent,
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private fbPhyInfra: FormBuilder,
    private fbFinancial: FormBuilder,
    private stpPayment: FormBuilder,
    private commonStorageService: CommonStorageService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationService: StpRegistrationService,
    private notification: NzNotificationService,
    private userStorageService: UserStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private financialStorageService: FinancialStorageService
  ) {

    this.stpApplicationId = this.route.snapshot.params.id;
    this.stpPrvAppId = this.route.snapshot.params.applicationId;
    if (!this.stpApplicationId) {
      this.stpApplicationId = Number(this.stpMainId);

    }
    // this.getUserProfile();

  }

  @ViewChild('basicProfileDetails') htmlData: ElementRef;

  ngOnInit() {
    this.currentUserInfo = localStorage.getItem('currentUserInfo');
    this.userInfo = JSON.parse(this.currentUserInfo) || null;
    if (this.userInfo) {
      this.userId = this.userInfo.id;
    }
    if (this.userInfo.roles[0].name.toLowerCase() === 'user' || this.userInfo.roles[0].name.toLowerCase() === 'stp_master') {
      this.isUser = true;
    }
    if (this.userInfo.roles[0].name.toLowerCase() === 'admin') {
      this.isAdmin = true;
    }

    this.basicProfileForm = this.fb.group({
      //#region Basic Profile
      stpName: [''],
      stpNameBangla: [''],
      stpTypeId: [''],
      // stpOwnerTypeId: ['', Validators.required],
      stpOwnershipTypeId: [''],
      stpMinistryId: [''],
      stpAgencyId: [''],
      establishYear: [''],
      stpLocationId: [''],

      //#endregion Basic Profile

      //#region Address of the organization

      stpCountryId: [''],
      stpPostOfficeId: [''],
      address: [''],
      contactNo: [''],
      email: [''],
      division_id: [''],
      district_id: [''],
      upazilla_id: [''],

      // don't find  (Website address) property from ERD

      //#endregion Address of the organization

      //#region Contact Person

      contactName: [''],
      contactDesignation: [''],
      contactNumber: [''],
      contactEmail: [''],

      //#endregion Contact Person

      //#region  commitee

      isCommittee: [''],
      totalMember: [''],
      totalFemaleMember: [''],
      approvalDateCommittee: [''],
      expirationDateCommittee: [''],
      // don't use my html upload tag
      //#endregion commitee

      //#region application details
      // stpApplicationStatusId: ['', Validators.required],
      // stpAppTypeId: ['', Validators.required],
      // registrationNo: ['', Validators.required],
      // approvalDate: ['', Validators.required],
      applicationDate: [''],
      stpApplicationStatus: [''],

      //#endregion application details
    });
    this.physicalInfraForm = this.fbPhyInfra.group({
      infrastructureName: ['demoName'],
      stpOwnershipStatus: [''],
      stpBuildingType: [''],
      totalArea: [''],
      noOfFloor: [''],
      noOfClassroom: [''],
      sizeOfClassroom: [''],
      noOfWorkshop: [''],
      sizeOfWorkshop: [''],
      noOfClub: [''],
      sizeOfClub: [''],
      noOfOffice: [''],
      noOfTrainerRoom: [''],
      noOfWashroom: [''],
      noOfFemaleWashroom: [''],
      isDisableFriendly: [{value: '', disabled: true}],
      isElectricity: [{value: '', disabled: true}],
      isInternet: [{value: '', disabled: true}],
      isDrinkingWater: [{value: '', disabled: true}],
      isFireEq: [{value: '', disabled: true}],
      isLibrary: [{value: '', disabled: true}],
      isLightingVent: [{value: '', disabled: true}],
    });
    this.financialDetailForm = this.fbFinancial.group({
      reserveFund: [null],
      fdr: [null],
      generalFund: [''],
      availableBalanceInBankAccount: [''],
      accountNumber: [''],
      bankName: [''],
      branchName: [''],
      otherFunds: [null],
      remarks: [''],
      feesFromStudents: [''],
      incomeFromOwnAssets: [''],
      fromGovernment: [''],
      developmentCharge: [''],
      admissionFee: [''],
      examinationFee: [''],
      sessionCharge: [''],
      sellingOfProductsProduced: [''],
      others_source: [''],
      salaryOfInstructorsAndStaff: [''],
      incidentalExpenses: [''],
      repairingCost: [''],
      examinationExpenses: [''],
      travelExpenses: [''],
      procurementOfBooks: [''],
      procurementOfTrainingLearningMaterials: [''],
      procurementOfRawMaterials: [''],
      others_head: [''],
    });
    this.paymentForm = this.stpPayment.group({
      amount: [''],
      generationDate: [''],
      successDate: [''],
      payDate: [''],
      bankName: [''],
      isSuccess: [''],
      paySlip: [''],
      transactionNo: [''],
    });

    this.approveRejectForm = this.fb.group({
      //#region Basic Profile
      rejectReason: [null]
    });
    this.getStpApplicationById();
    // this.getCommitteeByStpApplicationId();

    this.getFinancingApplicationNotificationByStpMainId();
  }

  getFinancingApplicationNotificationByStpMainId() {
    this.financialStorageService.getFinancingApplicationNotificationByStpMainId(this.stpApplicationId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.financingApplicationList = res?.data;
          }
        }
      });
  }

  // getUserProfile() {
  //   this.userStorageService.getUserProfile(this.userInfoId).subscribe({
  //     next: (response) => {
  //       this.userEmail = response.data?.email;
  //     },
  //     error: (error) =>
  //       this.notification.error('Failed', error.message),
  //   });
  // }

  private getStpApplicationById() {
    this.stpRegistrationStorageService
      .getPreviousStpAppInfoByStpMainId(this.stpApplicationId, this.stpPrvAppId)
      .subscribe(
        (res) => {
          // this.isTempRejected = res.data.stpTrainers[0].stpMain.isTempRejected

          // this.isTempRejected = res.data.stpUserInfoDto.isTempRejected;
          // this.approvalStatus = res.data.stpUserInfoDto.approvalStatus;
          //
          // this.fullStpApplicationDetails = res;
          //


          if (res.success) {
            // this.userInfoId = res.data.stpInfoDumpDto?.userId;

            // if(this.userInfoId != null){
            //   this.getUserProfile();
            // }

            this.stpEmail = res.data?.stpInfoDumpDto?.email;
            this.stpContactEmail = res.data?.stpInfoDumpDto?.contactEmail;
            this.stpExpireDate = res.data?.stpInfoDumpDto?.stpExpireDate;

            if (this.stpExpireDate && (new Date(this.stpExpireDate) < new Date())) {
              this.isStpExpired = true;
            }

            this.basicProfileForm.patchValue({
              stpName: res.data?.stpInfoDumpDto?.stpName,
              stpNameBangla: res.data?.stpInfoDumpDto?.stpNameBangla,
              stpTypeId: res.data?.stpInfoDumpDto?.stpType.typeName,
              stpOwnershipTypeId: res.data?.stpInfoDumpDto?.stpOwnershipType.typeName,
              stpMinistryId: res.data?.stpInfoDumpDto?.stpMinistry.ministryName,
              stpAgencyId: res.data?.stpInfoDumpDto?.stpAgency.agencyName,
              establishYear: this.datepipe.transform(
                res.data?.stpInfoDumpDto?.establishYear,
                'yyyy'
              ),
              stpLocationId: res.data?.stpInfoDumpDto?.stpLocation.locationName,

              stpCountryId: res.data?.stpInfoDumpDto?.sysCountry.countryName,
              stpPostOfficeId: res.data?.stpInfoDumpDto?.postOffice,
              address: res.data?.stpInfoDumpDto?.address,
              contactNo: res.data?.stpInfoDumpDto?.contactNumber,
              email: res.data?.stpInfoDumpDto?.contactEmail,
              division_id: res.data?.stpInfoDumpDto?.sysDivision.divisionName,
              district_id: res.data?.stpInfoDumpDto?.sysDistrict.districtName,
              upazilla_id: res.data?.stpInfoDumpDto?.sysUpazilla.upazillaName,

              contactName: res.data?.stpInfoDumpDto?.contactName,
              contactDesignation: res.data?.stpInfoDumpDto?.contactDesignation,
              contactNumber: res.data?.stpInfoDumpDto?.contactNumber,
              contactEmail: res.data?.stpInfoDumpDto?.contactEmail,

              isCommittee: res.data?.stpInfoDumpDto?.isCommittee,
              totalMember: res.data?.stpInfoDumpDto?.totalMember,
              totalFemaleMember: res.data?.stpInfoDumpDto?.totalFemaleMember,
              // approvalDateCommittee: res.data.stpUserInfoDto.approvalDate,
              approvalDateCommittee: this.datepipe.transform(
                res.data?.stpInfoDumpDto?.approvalDate,
                'dd-MM-yyyy'
              ),
              // expirationDateCommittee: res.data.stpUserInfoDto.expireDate,
              expirationDateCommittee: this.datepipe.transform(
                res.data?.stpInfoDumpDto?.expireDate,
                'dd-MM-yyyy'
              ),
              // applicationDate: res.data,
              // stpApplicationStatus: res.data,
              // dateOfCommencementPC: this.datepipe.transform(res.expCommencementDate, 'dd-MM-yyyy'),
              // dateOfCompletionPC: this.datepipe.transform(res.expCompletionDate, 'dd-MM-yyyy')
            });
            if (res.data?.stpInfoDumpDto?.isCommittee === true) {
              this.isCommitte = true;
            } else {
              this.isCommitte = false;
            }

            this.paymentForm.patchValue({
              amount: res.data?.stpPayments?.amount,
              generationDate: res.data?.stpPayments?.bankName,
              successDate: res.data?.stpPayments?.successDate,
              payDate: res.data.stpPayments.payDate.dayOfMonth + '-' + res.data.stpPayments.payDate.monthValue + '-' + res.data.stpPayments.payDate.year,
              // payDate: this.datepipe.transform(
              //   res.data?.stpPayments?.payDate,
              //   'dd-MM-YYYY'
              // ),
              bankName: res.data?.stpPayments?.bankName,
              isSuccess: res.data?.stpPayments?.isSuccess,
              paySlip: res.data?.stpPayments?.paySlip,
              transactionNo: res.data?.stpPayments?.transactionNo,
            });


            // if (res.data?.stpPayments?.stpPaymentType.id === 2) {
            if (res.data?.stpPayments?.stpPaymentType?.id === 2) {
              this.isManualPayment = true;
            }
            if (res.data?.stpPayments?.stpPaymentType?.id === 1) {
              this.isOnlinePayment = true;
              this.transactionNumber = res.data?.stpPayments?.transactionNo;
            }
            if (res.data?.stpPayments?.paySlip) {
              this.paySlip = res.data?.stpPayments?.paySlip;
            }
            this.physicalInfraForm.patchValue({
              stpOwnershipStatus: res.data?.infrustractureDumpDto?.stpOwnershipStatus.typeName,
              stpBuildingType: res.data?.infrustractureDumpDto?.stpBuildingType.typeName,
              totalArea: res.data?.infrustractureDumpDto?.totalArea,
              noOfFloor: res.data?.infrustractureDumpDto?.noOfFloor,
              noOfClassroom: res.data?.infrustractureDumpDto?.noOfClassroom,
              sizeOfClassroom: res.data?.infrustractureDumpDto?.sizeOfClassroom,
              noOfWorkshop: res.data?.infrustractureDumpDto?.noOfWorkshop,
              sizeOfWorkshop: res.data?.infrustractureDumpDto?.sizeOfWorkshop,
              noOfClub: res.data?.infrustractureDumpDto?.noOfClub,
              sizeOfClub: res.data?.infrustractureDumpDto?.sizeOfClub,
              noOfOffice: res.data?.infrustractureDumpDto?.noOfOffice,
              noOfTrainerRoom: res.data?.infrustractureDumpDto?.trainingRoom,
              noOfWashroom: res.data?.infrustractureDumpDto?.noOfWashroom,
              noOfFemaleWashroom: res.data?.infrustractureDumpDto?.noOfFemaleWashroom,
              isDisableFriendly: res.data?.infrustractureDumpDto?.isDisableFriendly,
              isElectricity: res.data?.infrustractureDumpDto?.isElectricity,
              isInternet: res.data?.infrustractureDumpDto?.isInternet,
              isDrinkingWater: res.data?.infrustractureDumpDto?.isDrinkingWater,
              isFireEq: res.data?.infrustractureDumpDto?.isFireEq,
              isLibrary: res.data?.infrustractureDumpDto?.isLibrary,
              isLightingVent: res.data?.infrustractureDumpDto?.isLightingVent,
            });

            this.financialDetailForm.patchValue({
              reserveFund: res.data?.fundDumpDto?.reserveFund ? parseFloat(res.data?.stpUserInfoDto?.reserveFund) : "NA",
              fdr: parseFloat(res.data?.fundDumpDto?.fdr),
              generalFund: parseFloat(res.data?.fundDumpDto?.generalFund),
              availableBalanceInBankAccount: parseFloat(
                res.data?.fundDumpDto?.availableBalance
              ),
              accountNumber: res.data?.fundDumpDto?.accountNo,
              bankName: res.data?.fundDumpDto?.bankName,
              branchName: res.data?.fundDumpDto?.branchName,
              otherFunds: parseFloat(res.data?.fundDumpDto?.otherFund),
              remarks: res.data?.fundDumpDto?.remarks,

              feesFromStudents: parseFloat(
                res.data?.incomeDumpDto?.feesFromStudent
              ),

              incomeFromOwnAssets: parseFloat(
                res.data?.incomeDumpDto?.ownAssetIncome
              ),
              fromGovernment: parseFloat(res.data?.incomeDumpDto?.govIncome),
              developmentCharge: parseFloat(
                res.data?.incomeDumpDto?.developmentCharge
              ),
              admissionFee: parseFloat(res.data?.incomeDumpDto?.admissionFee),
              examinationFee: parseFloat(res.data?.incomeDumpDto?.examFee),
              sessionCharge: parseFloat(
                res.data?.incomeDumpDto?.sessionCharge
              ),
              sellingOfProductsProduced: parseFloat(
                res.data?.incomeDumpDto?.prodSell
              ),
              others_source: parseFloat(res.data?.incomeDumpDto?.other),
              salaryOfInstructorsAndStaff: parseFloat(
                res.data?.expenseDumpDto?.salary
              ),
              incidentalExpenses: parseFloat(
                res.data?.expenseDumpDto?.incidental
              ),
              repairingCost: parseFloat(res.data?.expenseDumpDto?.repairing),
              examinationExpenses: parseFloat(res.data?.expenseDumpDto?.exam),
              travelExpenses: parseFloat(res.data?.expenseDumpDto?.travel),
              procurementOfBooks: parseFloat(
                res.data?.expenseDumpDto?.procBooks
              ),
              procurementOfTrainingLearningMaterials: parseFloat(
                res.data?.expenseDumpDto?.procTraining
              ),
              procurementOfRawMaterials: parseFloat(
                res.data?.expenseDumpDto?.procRawMat
              ),
              others_head: parseFloat(
                res.data?.expenseDumpDto?.others
              ),
            });

            this.totalIncomes =
              parseFloat(res.data.incomeDumpDto.feesFromStudent || 0) +
              parseFloat(res.data.incomeDumpDto.ownAssetIncome || 0) +
              parseFloat(res.data.incomeDumpDto.govIncome || 0) +
              parseFloat(res.data.incomeDumpDto.developmentCharge || 0) +
              parseFloat(res.data.incomeDumpDto.admissionFee || 0) +
              parseFloat(res.data.incomeDumpDto.examFee || 0) +
              parseFloat(res.data.incomeDumpDto.sessionCharge || 0) +
              parseFloat(res.data.incomeDumpDto.prodSell || 0) +
              parseFloat(res.data.incomeDumpDto.incomeOther || 0);

            this.totalExpenses =
              parseFloat(res.data.expenseDumpDto.salary || 0) +
              parseFloat(res.data.expenseDumpDto.incidental || 0) +
              parseFloat(res.data.expenseDumpDto.repairing || 0) +
              parseFloat(res.data.expenseDumpDto.exam || 0) +
              parseFloat(res.data.expenseDumpDto.travel || 0) +
              parseFloat(res.data.expenseDumpDto.procBooks || 0) +
              parseFloat(res.data.expenseDumpDto.procTraining || 0) +
              parseFloat(res.data.expenseDumpDto.procRawMat || 0) +
              parseFloat(res.data.expenseDumpDto.expenditureOthers || 0);

            this.stpTrainers = res.data.trainers;
            this.stpOccupationTools = res.data.toolsDumpDtos;
            this.furnitures = res.data.furnitureDumpDtos;
            this.stpManagements = res.data.stuffDumpDtos;
            this.isApplicationSubmitted = res.data.isApplicationSubmitted;
            this.stpRegistrationService.setCheckIsCompleteRegistration(this.isApplicationSubmitted);

            this.isComplete$ = this.stpRegistrationService
              .getCheckIsCompleteRegistration()
              .subscribe((res) => {
                this.isApplicationSubmitted = res;

              });

          } else {
            this.notification.error('Failed', 'STP Application Not Found!');
          }
        },
        (error) => {
          this.notification.error('Failed', 'STP Application Not Found!');
        }
      );
  }


  async openPDF() {
    let data = document.getElementById('basicProfileDetails')!;
    // let pdf = new jsPDF('p', 'mm', 'a4');
    // Reduced size of pdf
    let pdf = new jsPDF('p', 'mm', 'a4', true);
    let stpName = this.fullStpApplicationDetails.data?.stpUserInfoDto?.stpName ? this.fullStpApplicationDetails.data?.stpUserInfoDto?.stpName : 'report';
    let pdfName = stpName + '.pdf';
    await html2canvas(data).then(async (canvas) => {
      // Few necessary setting options
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      let pageNumber = 1;
      if (imgHeight % pageHeight != 0) {
        pageNumber = imgHeight / pageHeight + 1;
        pageNumber = Math.floor(pageNumber);
      } else {
        pageNumber = imgHeight / pageHeight;
      }

      let contentDataURL = canvas.toDataURL('image/png');
      var position = 0;
      while (pageNumber >= 0) {
        position = heightLeft - imgHeight;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        pageNumber--;

        if (pageNumber == 0) {
          break;
        }
        pdf.addPage();
      }
      // Generated PDF and downlonding PDF
      // pdf.save(pdfUrl);
      let blob = pdf.output('blob');
      // const formPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());
      // const pdfDoc = await PDFDocument.load(formPdfBytes);
      // const pdfBytes = await pdfDoc.save();
      this.pdfBlob = new File([blob], pdfName, {type: 'application/pdf'});
    });
  }

  onDownload(): void {
    // @ts-ignore
    this.commonStorageService.downloadFile(this.paySlip).subscribe(
      (data: any) => {
        var fileName = 'report.pdf';
        const contentDisposition = data.headers.get('Content-Disposition');
        if (contentDisposition) {
          const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = fileNameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }
        saveAs(data.body, fileName);
      },
      (err) => {
      }
    );
  }

  async onStpDownload() {
    await this.openPDF();
    saveAs(this.pdfBlob, this.pdfBlob.name);
  }

  setRejectApplication(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }


}
